// extracted by mini-css-extract-plugin
module.exports = {"container":"_3l7G6","nameButton":"_2oqnB","industryButton":"q-_Rc"};